// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1AuSo","footer":"ModalFilter_footer__1zfLB"};